import React from "react"
import { Button } from "react-bootstrap"
import BaseControl from "./BaseControl"

interface ButtonControlProps {
    text?: string;
    caption?: string;
    buttonLabel?: string;
    variant?: string;
    labelColor?: string;
    onClicked?: () => void;
    enabled?: boolean;
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const ButtonControl = ({
    text="Text",
    caption="",
    buttonLabel="button",
    variant="primary",
    labelColor="",
    onClicked=()=>{},
    enabled=true, // Add enabled prop with default true
    icon
}: ButtonControlProps) => {
    return <BaseControl textColor={labelColor} text={text} caption={caption} icon={icon}>
            <Button
                size="sm"
                variant={variant} 
                onClick={ (e) => onClicked()}
                disabled={!enabled} // Pass enabled prop to disable the button
            >
                {buttonLabel}
            </Button>
    </BaseControl>
}

export default ButtonControl
